import { lazy, Suspense, useCallback } from 'react';
import PageLoading from 'components/PageLoading';
import type { RouteConfig, ControlInfo } from 'Router';

const UnderMaintenance = lazy(() => import('pages/under-maintenance'));

export default function useControlRoute(
  routeConfig: RouteConfig[],
  controlData: ControlInfo[] | null
) {
  const controlRoute = useCallback(
    (routeConfig: RouteConfig[]) => {
      if (!controlData) return routeConfig;

      const result = routeConfig.map((route) => {
        if (route.name && controlData.length > 0) {
          const controlInfo = controlData.find(
            (data) => data.app_name === route.name
          );

          if (controlInfo) {
            const currentDate = new Date().getTime();

            if (
              currentDate >= controlInfo.start_date &&
              (!controlInfo.end_date || currentDate <= controlInfo.end_date)
            ) {
              return {
                ...route,
                element: (
                  <Suspense fallback={<PageLoading />}>
                    <UnderMaintenance message={controlInfo.message} />
                  </Suspense>
                ),
              };
            }
          }
        }
        return route;
      });
      return result;
    },
    [controlData]
  );

  return controlRoute(routeConfig);
}
